import {PlusCircleOutlined} from '@ant-design/icons';
import {
    Badge, Button, Form, Input, Tooltip,
} from 'antd';
import {FormInstance} from 'antd/es/form';
import {FormListFieldData} from 'antd/es/form/FormList';
import cn from 'classnames';
import {xor} from 'lodash-es';
import React, {
    useEffect,
    useRef,
    useState,
    FC,
} from 'react';

import {CheckboxWithToggle} from 'components/@common/specific/сheckbox-with-toggle/checkbox-with-toggle';
import {ColorPicker} from 'components/form/inputs/color-picker';
import {IFormListOperationsRef} from 'components/report-configuration/report-configuration.types';
import {SwitchFormatItemConditions} from 'components/report-configuration/tabs/report-table-settings/modals/switch-format-settings-modal-opener/switch-format-settings-modal-content/switch-format-item-conditions';
import {TStateSetter} from 'shared/types/generics';

interface IFormatFormItemProps {
    form: FormInstance;
    name: number;
    fields: FormListFieldData[];
    field: FormListFieldData;
    selectedRows: number[];
    setSelectedRows: TStateSetter<number[]>;
}

export const SwitchFormatFormItem: FC<IFormatFormItemProps> = ({
    form,
    name,
    setSelectedRows,
    selectedRows,
    field,
    fields,
}: IFormatFormItemProps) => {
    const conditionsRef = useRef<IFormListOperationsRef | null>(null);

    const [fieldsCount, setFieldsCount] = useState<number | undefined>(
        form.getFieldValue(
            ['reportTableColumns', 'customColumns', name, 'cases', field.name, 'conditions'],
        )?.length,
    );

    useEffect(() => {
        setFieldsCount(form.getFieldValue(
            ['reportTableColumns', 'customColumns', name, 'cases', field.name, 'conditions'],
        )?.length);
    }, [fields]);

    const [areConditionsHidden, setAreConditionsHidden] = useState(true);

    return (
        <div
            key={field.name}
            className={cn('switch-format-modal-content__form__row')}
        >
            <div className={cn('switch-format-modal-content__form__main')}>
                <div className={cn('switch-format-modal-content__form__row__top')}>
                    <CheckboxWithToggle
                        selected={selectedRows.includes(field.name)}
                        onToggleSelect={() => setSelectedRows(xor(selectedRows, [field.name]))}
                        fieldsCount={fieldsCount}
                        areConditionsHidden={areConditionsHidden}
                        setAreConditionsHidden={setAreConditionsHidden}
                    />
                    <Form.Item
                        rules={[{required: true}]}
                        label="Значение"
                        name={[field.name, 'value']}
                        style={{width: 200}}
                    >
                        <Input placeholder="Введите значение" />
                    </Form.Item>
                    <Form.Item
                        style={{width: 110}}
                        label="Цвет"
                        name={[field.name, 'color']}
                    >
                        <ColorPicker mode="fill" />
                    </Form.Item>
                    <Form.Item
                        label={<>&nbsp;</>}
                    >
                        <Tooltip
                            title="Добавить условие"
                            placement="right"
                            mouseEnterDelay={0.8}
                        >
                            <Badge
                                count={fieldsCount}
                                size="small"
                            >
                                <Button
                                    type="primary"
                                    className="btn-only-icon"
                                    onClick={() => {
                                        conditionsRef.current?.add();
                                        setFieldsCount(p => (p ?? 0) + 1);
                                        setAreConditionsHidden(false);
                                    }}
                                >
                                    <PlusCircleOutlined />
                                </Button>
                            </Badge>
                        </Tooltip>
                    </Form.Item>
                </div>
                <div className={cn('switch-format-modal-content__form__row__bottom')}>
                    <div className={cn('switch-format-modal-content__form__row__bottom__line')} />
                    <div className={cn(
                        'switch-format-modal-content__form__row__bottom__conditions',
                        {'switch-format-modal-content__form__row__bottom__conditions_hidden': areConditionsHidden},
                    )}
                    >
                        <Form.List
                            name={[field.name, 'conditions']}
                        >
                            {(conditionsFields, conditionsListOperations) => (
                                <SwitchFormatItemConditions
                                    ref={conditionsRef}
                                    form={form}
                                    currentFieldPath={
                                        ['reportTableColumns', 'customColumns', name, 'cases', field.name, 'conditions']
                                    }
                                    conditionsFields={conditionsFields}
                                    conditionsListOperations={conditionsListOperations}
                                    setFieldsCount={setFieldsCount}
                                />
                            )}
                        </Form.List>
                    </div>
                </div>
            </div>
        </div>
    );
};
